var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMobileYellowVector = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 340,
    viewBox: "0 0 393 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M761.495 106.688L305.199 9.08572C188.105 -15.9617 62.0881 22.1373 -25.6084 117.45C-90.2683 187.731 -137.922 300.514 -152.709 339.433",
    stroke: "#DFE33E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMobileYellowVector);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mobile_yellow_vector.c2029c710fc167223f9216c14c9b4362.svg";